import React, {Component} from 'react';
import axios from 'axios'
import ProcessButton from '../../../shared/process-button'

class Login extends React.Component {
	constructor ( props ) {
		super();
		this.state = {
			formSubmitted: false,
			loginError: false,
			email: '',
			password: '',
			remember: false,
			token: props.token
		};
		this.externalWindow = null;
	}

	handleChange = (event) =>{
	    this.setState({[event.target.name]: event.target.value });
	}

	handleRememberChange = (event) =>{
		this.setState({ remember: event.target.checked });
	}

	isButtonActive = () => {
		return this.state.email.length > 0 && this.state.password.length > 0
	}

	

	handleSubmit = (event) =>{

		event.preventDefault();

		this.setState({
			loginError: false,
			formSubmitted: true
		}, function() {
			axios.post( '/login.json', {
				authenticity_token: this.state.token,
				'session': {
					'email': this.state.email,
					'password': this.state.password,
					'remember_me': this.state.remember ? 1 : 0
				}
			}).then(response => {
				if( response.data.status ) {
					this.props.handleAuthSuccess( response.data.user );
				} else {
					this.setState({
						loginError: true,
						formSubmitted: false,
						token: response.data.token != undefined && response.data.token != null && response.data.token.length > 0 ? response.data.token : this.state.token
					});
				}
			}).catch(err => {
				this.setState({
					loginError: true,
					formSubmitted:false
				});
			});
		});
	}

	handleFacebookLogin = ( event ) => {
		event.preventDefault();
		const width = 400;
		const height = 600;
		const left = (screen.width/2)-(width/2);
		const top = (screen.height/2)-(height/2);
		this.externalWindow = window.open("/facebook-login?"+this.props.getRedirectUrl(true), 'oauthFB', "menubar=no,status=no,width="+width+",height="+height+",toolbar=no,left="+left+",top="+top);
	}

	render() {
				
		return (

			<form onSubmit={this.handleSubmit} action="/login" autoComplete="on" acceptCharset="UTF-8" method="post">

				<div className="backBtn"><span className="icon icon-left"></span><a onClick={this.props.handleViewChange.bind(null, 'message')}>Back</a></div>

				{this.state.loginError
					? <div className="callout danger">Login has failed</div>
					: null
				}

				{this.state.resetPassword ?
					<div className="password-reset">
						<div className="button large">
							<a onClick={this.props.handleViewChange.bind(null, 'reset')}>Reset your password</a>
						</div>
					</div>
				:null}


				<input value={this.state.email} onChange={this.handleChange} className="form-margin" placeholder="Your email address" type="email" name="email" />
				<input value={this.state.password} onChange={this.handleChange} className="form-margin" placeholder="Your password" type="password" name="password" />

				<div className="grid-x grid-margin-x">
					<div className="cell small-12 medium-6 text-left">
						<label className="checkbox inline tickbox-label-content" htmlFor="session_remember_me">
							<input checked={this.state.remember} onChange={this.handleRememberChange} type="checkbox" value="1" name="session[remember_me]" id="session_remember_me" />
							<span>Remember me</span>
						</label>
					</div>
				</div>

				<ProcessButton
					buttonType="submit"
					buttonClass="button primary expanded"
					disabled={!this.isButtonActive()}
					process={this.state.formSubmitted}
				>
					Login
				</ProcessButton>


				<div className="account-help">
					<p className="text-center"><a onClick={this.props.handleViewChange.bind(null, 'reset')}>Forgot your password?</a></p>
				</div>

				<div className="text-center">Don't have an account? <a onClick={this.props.handleViewChange.bind(null, 'signup')}>Sign up now!</a></div>

			</form>
		)
	}
}
export default Login
